// PrivateRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function PrivateRoute({ children }) {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    // 初始判斷尚未完成時不渲染內容（避免亂跳）
    return null;
  }

  if (!isAuthenticated) {
    // 未登入 → 導回登入頁，並保留目前位置
    return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
  }

  // 已登入，正常顯示內容
  return children;
}
